import { languageResourceEn } from './en';
import { languageResourceEs } from './es';
import { languageResourceFr } from './fr';
import { languageResourceFrCa } from './fr-CA';

export const languageResource = {
  en: {
    ...languageResourceEn,
  },
  fr: {
    ...languageResourceFr,
  },
  es: {
    ...languageResourceEs,
  },
  fr_ca: {
    ...languageResourceFrCa,
  }
};
